import React from 'react';
import { View, Text } from 'react-native';
import { trackEvent, TRACKING_EVENTS } from '@services/tracking';

const DatePicker = ({ C, wallboardTimelineEndDate, setWallboardTimelineEndDate, localTime, formatSinceDate, isSameDay, Arrow, isWeb }) => {
  const changeDate = (action) => {
    trackEvent(TRACKING_EVENTS.WALLBOARD, { action: 'dateChanged' });
    if (action === 'add') {
      setWallboardTimelineEndDate(localTime(wallboardTimelineEndDate).add(1, 'day').format());
    } else {
      setWallboardTimelineEndDate(localTime(wallboardTimelineEndDate).subtract(1, 'day').format());
    }
  };

  return (
    <View
      testID="wallboard-date-picker"
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: C('Button/Light/Secondary'),
        borderRadius: 20,
      }}
    >
      <Arrow
        {...{
          C,
          color: 'Button/Dark/Secondary Text',
          customStyle: { height: 27, width: 27 },
          iconWidth: 7,
          iconHeight: 12,
          onPress: () => changeDate('subtract'),
        }}
      />
      <Text
        style={[
          { color: C('Button/Dark/Secondary Text') },
          isWeb && {
            userSelect: 'none',
          },
        ]}
        numberOfLines={1}
      >
        {formatSinceDate(wallboardTimelineEndDate)}
      </Text>
      <Arrow
        {...{
          C,
          color: 'Button/Dark/Secondary Text',
          rotate: 180,
          customStyle: { height: 27, width: 27 },
          iconWidth: 7,
          iconHeight: 12,
          disabled: isSameDay(wallboardTimelineEndDate),
          onPress: () => changeDate('add'),
        }}
      />
    </View>
  );
};

export default DatePicker;
